import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const As2CertificateModalSchema = yup.object({
  /**
   * @example 1
   */
  id: yup.number(),
  /**
   * @example '-----BEGIN CERTIFICATE-----\nMIIG5DCC...........gfFA==\n-----END CERTIFICATE-----\n'
   */
  body: yup.string().required(REQUIRED_MESSAGE),
})

export type TAs2CertificateModalSchema = yup.InferType<typeof As2CertificateModalSchema>
